export class TermsAndConditionsModel {
  constructor(tenant, version, content, additionalImageUrl, personalDataProcessingClause) {
    this.tenant = tenant;
    this.version = version;
    this.content = content;
    this.additionalImageUrl = additionalImageUrl;
    this.personalDataProcessingClause = personalDataProcessingClause;
  }
}
